import { reactive, ref, unref, watch } from 'vue';
import { defineStore } from 'pinia'
import { useErrorHandling } from "../ErrorHandling";
import { debounce } from '@helpers/debounce'
import api from '../axios'
import axios from 'axios';
import { apiURL } from '../settings';

export const useSellerStore = defineStore('seller', () => {
  // States
  const listingBase = {
    // STEP 1
    register_number_id: '',
    odometer: '',
    location_address: '',
    location_zip: '',
    location_city: '',
    register_plate: '',
    make: '',
    model: '',
    year: '',
    fuel: '',
    drive: '',
    transmission:'',

    // STEP 2
    damage_type: '',
    additional_info: '',
    images: [],
    answers: {},

    // STEP 3
    first_name: '',
    last_name: '',
    email: '',
    mobile: '',
    address: '',
    city: '',
    zip: '',
    company: '',
    vat: '',
    accept_terms: false,
    allow_marketing: false,
    allow_sms: true,
  }

  const listing = ref(listingBase)

  let storedListing = sessionStorage.getItem('storedListing');
  if(storedListing !== null) {    
    let storedData = JSON.parse(storedListing)
    listing.value = Object.assign(listing.value, storedData)
  }

  const trafiData = ref({})
  
  const questions = ref([])

  const files = ref([]);
  const uploading = ref(false);
  const uploadedImgs = ref([]);
  const defaultImgIndex = ref(null);
  
  const listingDone = ref(false)

  const loading = reactive({
    getTrafiData: false,
    getQuestions: false,
    createListing: false,
  })
  
  const errors = reactive({
    getTrafiData: false,
    getQuestions: false,
    createListing: false,
  })

  const data = reactive({
    offeredCarData: {}
  })

  // Actions
  const setDefaultImgIndex = (index) => {
    defaultImgIndex.value = index;
  }

  const getTrafiData = async (regno) => {
    const registerNumber = unref(regno);
    try {
      loading.getTrafiData = true
      errors.getTrafiData = false      
      const trafiRes = await api.get('trafi/'+registerNumber.toUpperCase())
      trafiData.value = trafiRes.data
    } catch (error) {
      errors.getTrafiData = useErrorHandling(error)
    } finally {
      loading.getTrafiData = false
    }
  }

  const getQuestions = async () => {
    try {
      loading.getQuestions = true
      errors.getQuestions = false      
      const qRes = await api.get('questions')
      questions.value = qRes.data
      for (const question of questions.value) {        
        if(!listing.value.answers[question.id]) {
          listing.value.answers[question.id] = {
            value: null,
            extra: null
          };
        }                
      }     
    } catch (error) {
      errors.getQuestions = useErrorHandling(error)
    } finally {
      loading.getQuestions = false
    }
  }

  const createListing = async () => {
    const startUpload = () => {
      // console.log("MoiMoi", files.value);
      let uploads = []
      uploading.value = true


        if(!defaultImgIndex.value || defaultImgIndex.value == null) {
            defaultImgIndex.value = 0;
        }
      for (let i = 0; i < files.value.length; i++) {
          console.log("Uploading file", i);
          uploads.push(upload(i, files.value[i]))
      }

      return Promise.all(uploads).then(() => {
          // finished.value = true
      })
    }
    const upload = (index, file) => {
      console.log("Uploading", "defaultIndex", defaultImgIndex.value, "idnex", index);

      let data = new FormData();
      data.append("default", index == defaultImgIndex.value);
      data.append("file", file);
      // progress[index] = 0;

      let config = {
          headers: {
              "Content-Type": "multipart/form-data"
          },
          onUploadProgress: (event) => {
              let idx = index
              var percentCompleted = Math.round( (event.loaded * 100) / event.total );
              // progress.value[idx] = percentCompleted;
          }
      }

      return axios.post(apiURL+'image/upload', data, config)
          .then((res) => {
              uploadedImgs.value.push(res.data.picture)
          })
          .catch((err) => {
              let error = {
                  code: null,
                  message: null
              }
              if (err.response) {
                  // client received an error response (5xx, 4xx)
                  error.code = err.response.status
                  error.message = err.response.data.message
                  errors.value[index] = error
              } else if (err.request) {
                  // client never received a response, or request never left
                  error.code = 'errConn'
                  error.message = 'Network error!'
                  errors.value[index] = error
              } else {
                  error.code = 'errUnknown'
                  error.message = 'Unknown error!'
                  errors.value[index] = error
              }

          })
    }
    
    try {
      loading.createListing = true
      errors.createListing = false

      // Upload images before object creation as we need the img id's
      await startUpload();

      // Get the utm_data id from sessionStorage if it exists
      const savedUtmData = JSON.parse(sessionStorage.getItem('utm_data') ?? '{}');

      let postData = {
        first_name: listing.value.first_name,
        last_name: listing.value.last_name,
        address: listing.value.address,
        zip: listing.value.zip,
        city: listing.value.city,
        mobile: listing.value.mobile,
        email: listing.value.email,                
        company: listing.value.company,
        allow_marketing: listing.value.allow_marketing,
        seller_sub_sms: listing.value.allow_sms,
        transmission: listing.value.transmission,
          register_plate: trafiData.value.register_plate.toUpperCase(),
          make: listing.value.make,
          model: listing.value.model,
          year: listing.value.year,
          fuel: listing.value.fuel,
          drive: listing.value.drive,
        register_number_id: trafiData.value.id,
        odometer: listing.value.odometer,
        damage_type: listing.value.damage_type,
        damage_description: '',
        additional_info: listing.value.additional_info,
        location_address: listing.value.location_address,
        location_city: listing.value.location_city,
        location_zip: listing.value.location_zip,
        images: uploadedImgs.value.map((i) => i.id),
        answers: listing.value.answers,
        utm_id: savedUtmData?.id,
      }

      const res = await api.post('seller/car', postData);
      data.offeredCarData = res.data.car;
    } catch (error) {
      console.log(error);
      errors.createListing = useErrorHandling(error)
    } finally {
      loading.createListing = false
    }
  }

  const reset = () => {
    sessionStorage.removeItem('storedListing')
    listing.value = listingBase
    listingDone.value = false
  } 

  const debouncedLocalStore = debounce((nv, ov) => {
    sessionStorage.setItem('storedListing', JSON.stringify(listing.value))
  }, 500);

  watch(listing.value, debouncedLocalStore)

  return {
    listing,
    trafiData,
    questions,
    listingDone,
    data,
    loading,
    errors,
    files,
    getTrafiData,
    getQuestions,
    createListing,
    setDefaultImgIndex,
    reset
  }
})